import React from 'react'

const About = () => {
  return (
    <div>
      <h1>About this app</h1>
      <p>App to search Github users</p>
      <p>Version: 1.0.0 </p>
    </div>
  )
}

export default About
